
export function ifNoTextSetNull(value){

    if(value == '' ) {
        return null
      } else {
        return value
      }
}
